{ getSeparatorClassName } = require 'app/scripts/views/card/SeparatorCard/SeparatorCard'
cardTitleTemplate = require 'app/scripts/views/templates/card_title_on_card_front'
Util = require 'app/scripts/lib/util'
PopOver = require 'app/scripts/views/lib/pop-over'
QuickCardEditorView = require 'app/scripts/views/card/quick-card-editor-view'
{ track } = require '@trello/analytics'
TFM = require 'app/scripts/lib/markdown/tfm'
friendlyLinks = require 'app/scripts/views/internal/friendly-links'
Tooltip = require 'app/scripts/views/lib/tooltip'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports.renderName = ->
  data = @model.toJSON()
  data.separatorClassName = getSeparatorClassName(data.name)

  html = cardTitleTemplate(data)

  @$('.js-card-name').html html

  if featureFlagClient.get('remarkable.card-front-links', false) && !data.separatorClassName
    markedDownName = TFM.name.format(data.name).output
    if markedDownName
      @$('.js-card-name').html markedDownName
      friendlyLinks @$('.js-card-name')[0], @model.getBoard()

  @

module.exports.openQuickCardEditor = (e) ->
  if @options.quickEditHidden || !@model.editable()
    return

  Util.stop(e)
  PopOver.hide()
  QuickCardEditorView.open(@)
  track("Card Front", "Open Quick Card Editor", undefined, @model.trackProperty())

  @

module.exports.handleLinkInCardNameClick = (e) ->
  e?.stopPropagation()

module.exports.showTooltipForLinkInCardName = (e) ->
  $el = @$(e.target)
  url = $el.attr('href')

  if url
    Tooltip.show($el.attr('href'), $el, false, Tooltip.STYLE.MENU)

module.exports.hideTooltipForLinkInCardName = ->
  Tooltip.hide()
